module.exports = __webpack_public_path__ + "static/3-5b8233bee8682d06c7258ca3ae813952.jpg";